/**
 * The api service.
 */
const api = () => {

  const request = (method, url, data) => {
    return fetch(process.env.REACT_APP_API_URL + url,
        {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'Player': localStorage.getItem('player')
          },
          method: method,
          body: JSON.stringify(data)
        })
        .then(response => response.json())
        .then(data => data.data);
  }

  const login = (credentials) => {
    return request('POST', "auth/login", credentials)
  }

  const players = () => {
    return request('GET', "players")
  }

  const newPlayer = (data) => {
    return request('POST', "players", data)
  }

  const games = () => {
    return request('GET', "games")
  }

  const adventures = () => {
    return request('GET', "adventures")
  }

  const game = (id) => {
    return request('GET', `games/${id}`)
  }

  const newGame = (data) => {
    return request('POST', "games", data)
  }

  const updateGame = (gameId, data) => {
    return request('PATCH', "games/" + gameId, data)
  }

  const startGame = (gameId) => {
    return request('PATCH', "games/" + gameId + "/start")
  }

  const endGame = (gameId) => {
    return request('PATCH', "games/" + gameId + "/end")
  }

  const slots = () => {
    return request('GET', "slots")
  }

  const survey = () => {
    return request('GET', "survey")
  }

  const answerSurvey = (surveyId, data) => {
    return request('POST', "surveys/" + surveyId + "/answer", data)
  }

  const characters = () => {
    return request('GET', "characters")
  }

  return {
    adventures,
    login,
    players,
    newPlayer,
    games,
    slots,
    characters,
    newGame,
    game,
    updateGame,
    startGame,
    endGame,
    survey,
    answerSurvey
  }
}

export default api
